import React from 'react';

function KidneyProfileForm() {
  return (
    <div>
      <h2>KidneyProfileForm</h2>
    </div>
  );
}

export default KidneyProfileForm;
